import React, { Component } from "react";
import { Link } from "react-router-dom";
import { setAdminLang, getName, clearStorage } from "../../localstorage-service";
import Spinner from "../User/Common/Spinner/Spinner";
import { changeUserLanguage } from "../../data-service-admin";
import { ToastContainer } from "react-toastr";
import { showToastMessage } from "../../utilities";

class AdminHeader extends Component {
  state = {
    showSpinner: false,
  };

  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow,
    });
  }
  changeLanguage(from, to) {
    const data = {
      from: to,
      to: from,
    };
    this.showSpinner(true);
    changeUserLanguage(data)
      .then((response) => {
        this.showSpinner(false);
        setAdminLang(from);
        window.location.reload();
      })
      .catch((error) => {
        this.showSpinner(false);
        showToastMessage("error", `Error`, `Error in changing language. Contact IT administrator`, this, "toastr1");
      });
  }
  logout() {
    clearStorage();
  }
  render() {
    return (
      <nav className="navbar navbar-inverse navbar-fixed-top">
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <div className="container-fluid">
          <div>
            <Link to="/admin/modules/" className="navbar-brand pull-left">
              ASML
            </Link>
            <div id="navbar" className="pull-right">
              {/* <a onClick={() => this.changeLanguage("en-US", "zh-cn")}>
                <img
                  src="/images/english.png"
                  className={getAdminLang() === "en-US" ? "mt-15" : "mt-15 redopacity"}
                  width="25px"
                  alt="english"
                />
              </a>
              |
              <a onClick={() => this.changeLanguage("zh-cn", "en-US")}>
                <img
                  src="/images/chinese.png"
                  width="25px"
                  className={getAdminLang() === "zh-cn" ? "mt-15" : "mt-15 redopacity"}
                  alt="chinese"
                />
              </a> */}
              <ul className="nav navbar-nav navbar-right">
                <li>
                  <div
                    style={{
                      position: "relative",
                      display: "block",
                      padding: "15px 15px",
                      color: "#ffffff",
                      lineHeight: "20px",
                    }}
                  >
                    Welcome back, <strong>{getName()}</strong>!
                  </div>
                </li>
                <li>
                  <Link onClick={() => this.logout()} to="/admin/login">
                    Logout
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default AdminHeader;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminHeader.js